import * as React from "react";
const SvgBattery0ChargingHorizontal24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 14,
        fill: "black",
        viewBox: "0 0 24 14"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M0 0h22v4h2v6h-2v4H0V0Zm2 2v10h8.05L11 8.2H5L11.2 2H2Zm18 10h-9.2L17 5.8h-6l.95-3.8H20v10Z",
      clipRule: "evenodd"
    })
  );
export default SvgBattery0ChargingHorizontal24Px;
